import axios from "axios";

export const fetchAllUsers = async (cancelToken) => {
    try {
        const { data } = await axios.get(`/api/users`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const fetchUser = async (id, cancelToken) => {
    try {
        const { data } = await axios.get(`/api/users/${id}`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const oversightVerification = (creds) => {
    console.log(creds);
    return axios.post(`/api/users/verify-supervisor`,creds)

}

export const updateUserIdleStatus =(status,id)=>{
   let payload={
       status:status,
       id:id
   }
    return axios.post(`/api/users/updateIdle`, payload)
}


//updates progress of assignments
export const updateAssignments = (payload) => {
    return axios.patch(`/api/users/assignments`, payload)
}

export const updateWIAssignments = (users, workInstuctionId) => {
    return axios.patch(`/api/users/${workInstuctionId}/assignments`, users)
}

export const updateUserStepsDone = (payload) => {
    return axios.patch(`/api/users/stepsDone`, payload)
}

export const addNotification = (payload) => {
    console.log("new notification added")
    return axios.post(`/api/users/${payload.user_id}/notifications/new`, payload)
};

export const updateUsersNotificationRead = (userId) => {
    return axios.patch(`/api/users/${userId}/notifications/update`);
};

export const updateUserIDSetToNotification = async (userId, fetchUnread) => {
    let payload = {
        userId: userId,
        fetchUnread: fetchUnread
    }
    return axios.patch(`/api/notifications/${userId}/read`, payload)
    // return update
}

export const fetchAllNotifications = async (fetchUnread, userId) => {
    let payload={
        fetchUnread,
        userId
    }
    const {data} = await axios.post(`/api/notifications`, payload)
    console.log('NOTIS INSIDE UTIL', data)
    return data;
};

export const createUser = async (user) => {
    try {
        const response = await axios.post(`/api/users/create`, user);
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const fetchUserNotifications = async (userId) => {
    try {
        const { data } = await axios.get(`/api/users/${userId}/notifications`)
        return data
    } catch (error) {
        throw error
    }
};

export const fetchIncomingNotifications = async (userId) => {
    let payload = {
        fetchUnread: true, // Set fetchUnread to true
        userId
    };
    const { data } = await axios.post(`/api/notifications/filtered`, payload);
    return data;
};

export const fetchUserFeedback = async (username, cancelToken) => {
    try {
        const { data } = await axios.get(`/api/feedback/${username}`, { cancelToken });
        return data
    } catch (error) {
        throw error
    }
};


export const online = async () => {
    // Ping the server endpoint to check reachability
    try {
        // We expect a 204 No Content on success. Add a timeout.
        await axios.get(`/api/users/online`, { timeout: 5000 });
        // If the request resolves without throwing an error, assume connectivity.
        return true;
    } catch (error) {
        // Any error during the request (network error, timeout, non-2xx status) indicates offline or server issue
        console.error("Online status check failed:", error);
        return false;

    }
};

export const updateUserRole = payload => {
    return axios.patch(`/api/users/${payload.user_id}/role`, payload)
}

// export const storeProfileImage = (userId, image) => {
//     const payload = {
//         image
//     }
//     return axios.patch(`api/users/${userId}/profile-image`, payload)
// }
export const storeProfileImage = (userId, image) => {
    const payload = {
        image
    }
    return axios.patch(`/api/users/${userId}/profile-image`, payload)
        .then(response => {
            return {
                id: response.data._id,
                image: response.data.image
            };
        });
}
